import { render, staticRenderFns } from "./slideBox.vue?vue&type=template&id=1715449e&scoped=true&"
import script from "./slideBox.vue?vue&type=script&lang=js&"
export * from "./slideBox.vue?vue&type=script&lang=js&"
import style0 from "./slideBox.vue?vue&type=style&index=0&id=1715449e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715449e",
  null
  
)

export default component.exports